<div class="relative rounded-[12px] overflow-hidden branch-slider">
	<owl-carousel-o [options]="customOptions">
		<ng-template
			carouselSlide
			*ngFor="let image of branchInformationData?.sliderImages; let i = index"
		>
			<div
				class="overlay before:top-0 before:left-0 before:w-full before:h-full before:absolute before:bg-opacity-20"
			>
				<img
					class="rounded-[12px]"
					[src]="attachmentUrl + image?.coverViewUrl"
					alt="pic"
					onerror="this.src='assets/images/empty state.jpg'"
				/>
				<div class="flex justify-between absolute bottom-[12px] right-[12px]">
					<div class="flex px-2">
						<button
							*ngIf="branchInformationData.sliderImages.length < 5"
							(click)="uploadSliderImage()"
							class="bg-gradient relative text-off-white rounded max-mobile:p-1 max-mobile:h-[25px]"
							mat-button
						>
							<div
								class="flex justify-center max-mobile:h-[22px] leading-[25px]"
							>
								<img
									class="lg:w-7 w-5 mb-[2px] max-mobile:hidden"
									src="assets/images/add-white.svg"
									alt="add"
								/>
								<p
									class="mt-1 mb-[3px] max-mobile:text-[8px] max-mobile:m-0 max-mobile:leading-[20px]"
								>
									{{ 'ACTIONS.ADD_IMG_Branch' | translate }}
								</p>
							</div>
						</button>
						<div
							class="relative border border-off-white rounded mx-2 px-1"
							(click)="openMenu = !openMenu"
						>
							<mat-icon class="text-white mt-2 cursor-pointer"
								>more_vert</mat-icon
							>
						</div>
						<div
							*ngIf="openMenu"
							class="absolute ltr:right-0 rtl:left-0 bottom-[45px] rounded-[12px] z-50 bg-[#1C252E] p-6 items-start"
						>
							<div
								(click)="handleBeforSave(true, i)"
								class="relative hover:bg-none text-white max-mobile:p-0 p-0 py-0 cursor-pointer"
								mat-button
							>
								<div
									class="flex ltr:justify-start rtl:justify-end leading-[25px]"
								>
									<img
										class="w-6 max-mobile:hidden"
										src="assets/images/delete-white.svg"
										alt="delete"
									/>
									<p
										class="ltr:ml-2 rtl:mr-2 my-0 max-mobile:text-[8px] max-mobile:m-0 max-mobile:ltr:ml-0 max-mobile:rtl:mr-0 max-mobile:leading-[24px]"
									>
										{{ 'ACTIONS.DELETE_IMG' | translate }}
									</p>
								</div>
							</div>
							<hr class="w-full my-3" />
							<div class="ms-1 py-0 text-white">
								<mat-checkbox
									[disabled]="image?.isDefault ? true : false"
									[checked]="image?.isDefault ? true : false"
									class="ltr:mr-2 rtl:ml-2"
									value="{{ image?.isDefault ? true : false }}"
									(change)="setImgAsDefaul(image.id); openMenu = !openMenu"
								></mat-checkbox>
								{{ 'ACTIONS.AS_DEFULT' | translate }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-template>
		<ng-template
			carouselSlide
			*ngIf="!branchInformationData?.sliderImages?.length"
		>
			<img
				class="rounded-[12px]"
				src="assets/images/empty state.jpg"
				alt="pic"
			/>
			<div
				class="flex justify-between absolute bottom-[12px] ltr:right-[12px] rtl:left-[12px]"
			>
				<div class="flex px-2">
					<button
						(click)="uploadSliderImage()"
						class="bg-gradient relative text-off-white rounded"
						mat-button
					>
						<div class="flex justify-center">
							<img
								class="lg:w-7 w-5 mb-2"
								src="assets/images/add-white.svg"
								alt="add"
							/>
							<p class="mt-1">{{ 'ACTIONS.ADD_IMG_Branch' | translate }}</p>
						</div>
					</button>
				</div>
			</div>
		</ng-template>
	</owl-carousel-o>
</div>
